import { css } from 'styled-components';
import {
  getTypography, getSpacing, TypographyName, SpacingName, ThemedFunctor, FontWeight,
} from '@doveit/lego';

export const base: ThemedFunctor = ({
  theme,
}) => css`
  color: ${theme.palettes.neutrals.darkest};
  position: relative;
  cursor: pointer;
  max-height: 100%;
`;

export const imageWrapper: ThemedFunctor = ({
  theme,
}) => css`
  background-color: ${theme.palettes.neutrals.lighter};

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`;

export const imagePlaceholder = css`
  padding-top: 66%;
  width: 100%;
`;

export const info: ThemedFunctor = ({
  theme,
}) => css`
    margin-top: ${theme.spaceUnits.mobile.MEDIUM};
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}
  font-weight: ${FontWeight.BOLD};

  a {
    color: ${theme.palettes.neutrals.darkest};
    text-decoration: none;
  }
`;

export const abstract: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}
  ${getTypography(theme, TypographyName.SMALL)}
  line-height: 1.4 !important;
  color: ${theme.palettes.neutrals.dark};
`;
